import { PROTOTYPE_STENCIL_SLUG, TOP_SIDE, STENCIL_TOP_SIDE, basicStencils } from "../data/StencilsConstants";

export const deleteStencilsFromCart = (state, called_from_cart=false) => {
  const idDestroy = state.stencils.filter((s) => s.line_item_id !== undefined).map((s) => s.line_item_id);
  if (idDestroy.length) {
    state.stencilsToDestroy.push(...idDestroy);
  }
  state.stencilsToDestroy = [...new Set(state.stencilsToDestroy)]

  if(called_from_cart){
    state.stencilsParameters = {};
    state.stencils = [];
    state.stencilsToBuy = [];
    state.stencilsSide = null;

    state.stencilsType = PROTOTYPE_STENCIL_SLUG;
    state.stencilsSide = TOP_SIDE;

    let stencil = _.cloneDeep(basicStencils)
    stencil.product = Spree.stencils_info.find((s) => s.slug === PROTOTYPE_STENCIL_SLUG);
    stencil.parameters.stencil_side = STENCIL_TOP_SIDE;
    state.stencils.push(stencil);
  }
}